import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog.component';
import { ConfirmDialog } from '../models/confirm-dialog';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(private dialog: MatDialog) { }

  show(title: string, message: string) : Observable<boolean> {
    const confirmDialog: ConfirmDialog = {
      title: title,
      message: message,
    }
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: confirmDialog,
      autoFocus: true,
      disableClose: true
    });

    return ref.afterClosed();
  }
}
